// extracted by mini-css-extract-plugin
module.exports = {"stroke-str":"Carousel_stroke-str__KInkA"};